import MobileLandingRecoveryComponent from "./MobileLandingRecoveryComponent.vue";

const mobileLandingRecoveryCtrl = new Vue({
    el: '#mobile-landing-recovery',
    components: {MobileLandingRecoveryComponent: MobileLandingRecoveryComponent}
});
